import { useRequest } from 'ahooks'
import { Form } from 'antd'
import moment from 'moment'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { SpecialProjectLocalStorageModal } from '@/components/special-project-local-storage-modal'
import { routes } from '@/router'
import { SpecialProjectFormLocalStorageKey } from '@/schemas'

import { CustomerForm } from './customer-form/customer-form.component'
import { Customer } from './customer.schema'

export const CustomerCreate: React.FC<{ customer?: Customer }> = () => {
  const history = useHistory()
  const [form] = Form.useForm()
  const { run: onSubmit } = useRequest(
    (data) => ({
      url: '/api/customer',
      method: 'post',
      data,
    }),
    {
      manual: true,
      onSuccess: (data: Customer) => {
        history.push(routes.customer.detail(data.selfId))
      },
    }
  )

  return (
    <>
      <CustomerForm form={form} onSubmit={onSubmit} />
      <SpecialProjectLocalStorageModal
        localStorageKey={SpecialProjectFormLocalStorageKey.CUSTOMER}
        onSetForm={(value) => {
          form.setFieldsValue({
            ...value,
            range: value.range ? [moment(value.range[0]), moment(value.range[1])] : undefined,
            expectTime: moment(value.expectTime),
            localCacheExpireTime: undefined,
          })
        }}
      />
    </>
  )
}
